export default "__VITE_ASSET__nTlfQLhb__"